import React, { useState, useEffect } from "react";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import { Popover, Select, Spin, Switch } from "antd";
import axios from "axios";
// import Swal from "sweetalert2";
import dayjs from "dayjs";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";
import { MailOutlined } from "@ant-design/icons";

const Inactiveclients = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loadingProducts, setLoadingProducts] = useState(true);

  // const columns = [
  //   {
  //     title: "Super ID",
  //     dataIndex: "SuperId",
  //     sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
  //   },
  //   {
  //     title: "Client",
  //     dataIndex: "OrgName",
  //     render: (_, record) => {
  //       const truncated =
  //         record?.OrgName?.length > 45
  //           ? record?.OrgName?.substring(0, 45) + "..."
  //           : record?.OrgName;
  //       return <span title={record?.OrgName}>{truncated}</span>;
  //     },

  //     sorter: (a, b) => (a?.OrgName || "").localeCompare(b?.OrgName || ""),
  //   },

  //   {
  //     title: "Subscribed On",
  //     dataIndex: "SubscribedOn",
  //     sorter: (a, b) =>
  //       dayjs(a?.SubscribedOn, "DD-MM-YYYY").valueOf() -
  //       dayjs(b?.SubscribedOn, "DD-MM-YYYY").valueOf(),
  //   },
  //   {
  //     title: "Renewal Date",
  //     dataIndex: "RenewalDt",
  //     sorter: (a, b) =>
  //       dayjs(a?.RenewalDt, "DD-MM-YYYY").valueOf() -
  //       dayjs(b?.RenewalDt, "DD-MM-YYYY").valueOf(),
  //     render: (text) => {
  //       const today = new Date();
  //       const renewal = new Date(text?.split("-").reverse().join("-"));
  //       const isExpired = renewal < today;
  //       return (
  //         <span className={isExpired ? "text-danger fw-semibold" : ""}>
  //           {text}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "SubscriptionStatus",
  //     render: (_, record) => (
  //       <Switch
  //         size="small"
  //         checked={record.SubscriptionStatus === "1"}
  //         checkedChildren={null}
  //         unCheckedChildren={null}
  //         // onChange={(value) => handleStatusToggle(value, record)}
  //         style={{
  //           backgroundColor:
  //             record.SubscriptionStatus === "1" ? "#00b96b" : "#ff4d4f",
  //         }}
  //       />
  //     ),
  //   },
  // ];
  const columns = [
    {
      title: "SuperId",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "Client",
      dataIndex: "OrgName",
      // render: (_, record) => {
      //   const truncated =
      //     record?.OrgName?.length > 45
      //       ? record?.OrgName?.substring(0, 45) + "..."
      //       : record?.OrgName;
      //   return (
      //     <div className="d-flex align-items-center gap-4">
      //       <span
      //         className={
      //           record?.IsActive
      //             ? "badge bg-success rounded-circle"
      //             : "badge bg-danger rounded-circle"
      //         }
      //         style={{
      //           width: 15,
      //           height: 15,
      //           display: "inline-block",
      //         }}
      //       ></span>
      //       <span title={record?.OrgName}>{truncated}</span>
      //     </div>
      //   );
      // },

      sorter: (a, b) => (a?.OrgName || "").localeCompare(b?.OrgName || ""),
    },

    {
      title: "Product",
      dataIndex: "ProductType",
      sorter: (a, b) =>
        (a?.ProductType || "").localeCompare(b?.ProductType || ""),
    },
    {
      title: "Email",
      dataIndex: "PrimaryEmailAddr",
      render: (text) => {
        if (!text) return "-";

        const content = (
          <div style={{ maxWidth: 220, wordBreak: "break-word" }}>{text}</div>
        );

        return (
          <Popover
            content={content}
            trigger={["hover", "click"]}
            placement="top"
          >
            <MailOutlined style={{ cursor: "pointer", fontSize: 16 }} />
          </Popover>
        );
      },
      sorter: (a, b) =>
        (a?.PrimaryEmailAddr || "").localeCompare(b?.PrimaryEmailAddr || ""),
    },
    {
      title: "Mobile",
      dataIndex: "PrimaryMobile",
      render: (value) => (value ? value : "-"),
    },
    {
      title: "SubscribedOn",
      dataIndex: "SubscribedOn",
      sorter: (a, b) => {
        const d1 = dayjs(a?.SubscribedOn, "DD-MM-YY", true);
        const d2 = dayjs(b?.SubscribedOn, "DD-MM-YY", true);

        return (
          (d1.isValid() ? d1.valueOf() : 0) - (d2.isValid() ? d2.valueOf() : 0)
        );
      },
    },
    {
      title: "Renewal Date",
      dataIndex: "RenewalDt",
      sorter: (a, b) =>
        dayjs(a?.RenewalDt, "DD-MM-YYYY").valueOf() -
        dayjs(b?.RenewalDt, "DD-MM-YYYY").valueOf(),
      render: (text) => {
        const today = new Date();
        const renewal = new Date(text?.split("-").reverse().join("-"));
        const isExpired = renewal < today;
        return (
          <span className={isExpired ? "text-danger fw-semibold" : ""}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "SubscriptionStatus",
      render: (_, record) => (
        <Switch
          size="small"
          checked={record.SubscriptionStatus === "1"}
          checkedChildren={null}
          unCheckedChildren={null}
          // onChange={(value) => handleStatusToggle(value, record)}
          style={{
            backgroundColor:
              record.SubscriptionStatus === "1" ? "#00b96b" : "#ff4d4f",
          }}
        />
      ),
    },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   render: (_, record) => (
    //     <div className="action-icon d-inline-flex align-items-center">
    //       <Link
    //         to="#"
    //         className="p-2 d-flex align-items-center border rounded me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#company_detail"
    //         onClick={() => fetchCompanyDetail(record)}
    //       >
    //         <i className="ti ti-eye" />
    //       </Link>
    //       <Link
    //         to="#"
    //         className="me-2 p-2 d-flex align-items-center border rounded"
    //         data-bs-toggle="modal"
    //         data-bs-target="#Notification"
    //         onClick={() => fetchCompanyDetails(record)}
    //       >
    //         <i className="ti ti-bell" />
    //       </Link>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   render: (_, record) => {
    //     const items = [
    //       {
    //         key: "1",
    //         label: (
    //           <div
    //             data-bs-toggle="modal"
    //             data-bs-target="#company_detail"
    //             onClick={() => fetchCompanyDetail(record)}
    //           >
    //             <i className="ti ti-eye me-2" />
    //             View Details
    //           </div>
    //         ),
    //       },
    //       {
    //         key: "2",
    //         label: (
    //           <div
    //             data-bs-toggle="modal"
    //             data-bs-target="#EditClient"
    //             onClick={() => setSelectedEditRecord(record)}
    //           >
    //             <i className="ti ti-edit me-2" />
    //             Edit Client
    //           </div>
    //         ),
    //       },
    //       {
    //         key: "3",
    //         label: (
    //           <div
    //             data-bs-toggle="modal"
    //             data-bs-target="#Notification"
    //             onClick={() => setSelectedNotifyRecord(record)}
    //           >
    //             <i className="ti ti-bell me-2" />
    //             Send Notification
    //           </div>
    //         ),
    //       },
    //       {
    //         key: "4",
    //         label: (
    //           <div
    //             data-bs-toggle="modal"
    //             data-bs-target="#locationModal"
    //             onClick={() => setSelectedLocationRecord(record)}
    //           >
    //             <i className="ti ti-current-location me-2" />
    //             Location
    //           </div>
    //         ),
    //       },
    //       {
    //         key: "5",
    //         label: (
    //           <div
    //             data-bs-toggle="modal"
    //             data-bs-target="#devicemodel"
    //             onClick={() => setSelectedDeviceRecord(record)}
    //           >
    //             <i className="ti ti-device-desktop me-2" />
    //             Devices
    //           </div>
    //         ),
    //       },
    //       {
    //         key: "6",
    //         label: (
    //           <div
    //             data-bs-toggle="modal"
    //             data-bs-target="#configurationmodel"
    //             onClick={() => setSelectedConfigRecord(record)}
    //           >
    //             <i className="fa-solid fa-gears me-2"></i>
    //             Configurations
    //           </div>
    //         ),
    //       },
    //       {
    //         key: "7",
    //         label: (
    //           <div
    //             data-bs-toggle="modal"
    //             data-bs-target="#generatelicence"
    //             onClick={() => setSelectedGeneratedLicence(record)}
    //           >
    //             <i className="fa-solid fa-key me-2"></i>
    //             Generate Licence
    //           </div>
    //         ),
    //       },
    //     ];

    //     return (
    //       <Dropdown
    //         menu={{ items }}
    //         trigger={["click"]}
    //         placement="bottomRight"
    //       >
    //         <Link
    //           to="#"
    //           className="p-2 d-flex align-items-center justify-content-center"
    //         >
    //           <i className="ti ti-dots-vertical" />
    //         </Link>
    //       </Dropdown>
    //     );
    //   },
    // },
  ];

  const getInactiveOrganizations = async (selectedProduct) => {
    setLoading(true);
    try {
      const response = await axios.get(
        // `${API_BASE_URL}api/getinactiveorganizations`,
        `${API_BASE_URL}api/org/getallorganization?ProductId=${selectedProduct}&IsActive=0`
      );
      const data = response.data?.ResultData || [];
      setOrganizations(data);
    } catch (error) {
      console.error("Error fetching inactive organizations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedProduct === null) return;
    getInactiveOrganizations(selectedProduct);
  }, [selectedProduct]);

  const fetchProducts = async () => {
    try {
      setLoadingProducts(true);
      const res = await fetch(`${API_BASE_URL}api/type/getproducttype`);

      if (!res.ok) throw new Error("Failed to fetch productOptions");
      const data = await res.json();

      if (data.status === true) {
        setProductOptions([
          { label: "All", value: 0 },
          ...data.ResultData.map((item) => ({
            label: item.ProductName,
            value: item.Id,
          })),
        ]);
      }
    } catch (error) {
      console.error("Error fetching productOptions:", error);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // const handleStatusToggle = async (value, record) => {
  //   const newStatus = value ? "1" : "0";

  //   try {
  //     const response = await fetch(`${API_BASE_URL}/api/orgdelete`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         SuperId: String(record.SuperId),
  //         IsActive: newStatus,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (data.ResultData[0].Status === "1") {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Status Updated",
  //         text: `Client is now ${newStatus === "1" ? "Active" : "Inactive"}`,
  //       });

  //       // Reload table
  //       getInactiveOrganizations();
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Update Failed",
  //         text: data.ResultMessage || "Error updating status",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Status update error:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Server Error",
  //       text: "Unable to update status",
  //     });
  //   }
  // };

  const handleRefresh = () => {
    window.location.reload();
  };
  useEffect(() => {
    if (productOptions?.length > 0 && selectedProduct === null) {
      setSelectedProduct(Number(productOptions[0].value));
    }
  }, [productOptions]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Inactive Clients</h4>
                <h6>Manage your inactive clients</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
            </ul>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <h5 className="mb-3"></h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Select
                    placeholder="Select Product"
                    style={{ width: 150 }}
                    loading={loadingProducts}
                    options={productOptions}
                    onChange={(value) => setSelectedProduct(Number(value))}
                    value={selectedProduct}
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table columns={columns} dataSource={organizations} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </>
  );
};

export default Inactiveclients;
